import { ClickAwayListener, Typography } from "@mui/material";
import React from "react";
import ReactDraggable from "react-draggable";
import styled from "styled-components";
import { ArrowDownIcon } from "../../../CommonUI/Icon/ArrowDownIcon";
import { BranchIcon } from "../../../CommonUI/Icon/BranchIcon";
import { CloseRedIcon } from "../../../CommonUI/Icon/CloseRedIcon";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { FlowEditContext } from "../../FlowEditContext";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowSequenceCompleteStrategy } from "../../../rule-engine-core/Flow/Structure/FlowSequenceCompleteStrategy";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const SequenceStrategyDialog = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    box-sizing: border-box;
    box-shadow: 0px 6px 8px -2px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    border-radius: 4px;
    position: absolute;
    z-index: 10;

    display: flex;
    flex-direction: column;

    padding: 16px 16px 4px;

    .SequenceStrategyDialog-title {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 140%;

        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

        margin-bottom: 12px;
    }
`;

const SequenceStrategyLineDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;

    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 140%;

    cursor: pointer;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    &:hover {
        color: ${UIStyleConstants.BLUE_COLOR};
    }
`;

interface ISeqeuenceStrategyEditDialog {
    editContext: FlowEditContext;
}

export const SeqeuenceStrategyEditDialog: React.FC<ISeqeuenceStrategyEditDialog> = (
    props: ISeqeuenceStrategyEditDialog,
) => {
    function updateSequenceStrategy(sequence: FlowStepSequence, strategy: FlowSequenceCompleteStrategy) {
        sequence.strategy = strategy;
        props.editContext.selectedSequenceStrategy = null;
    }

    return (
        <ObserveState
            listenTo={props.editContext}
            properties={[FlowEditContext.SHOW_SEQUENCE_STRATEGY]}
            control={() => {
                if (!props.editContext.selectedSequenceStrategy) {
                    return <></>;
                }

                let { sequence, position } = props.editContext.selectedSequenceStrategy;
                return (
                    <ClickAwayListener onClickAway={() => (props.editContext.selectedSequenceStrategy = null)}>
                        <ReactDraggable
                            handle=".SequenceStrategyDialog-title"
                            defaultPosition={position}
                        >
                            <SequenceStrategyDialog data-testid="sequence-strategy-dialog">
                                <Typography className={"SequenceStrategyDialog-title"}>
                                    {sequence?.name} Strategies
                                </Typography>
                                <SequenceStrategyLineDiv
                                    onClick={() => updateSequenceStrategy(sequence, FlowSequenceCompleteStrategy.LINK)}
                                    data-testd="sequence-strategy-branch"
                                >
                                    <BranchIcon /> Link to sequence
                                </SequenceStrategyLineDiv>
                                {sequence.canReturn() && (
                                    <SequenceStrategyLineDiv
                                        onClick={() =>
                                            updateSequenceStrategy(
                                                sequence,
                                                FlowSequenceCompleteStrategy.RETURN_TO_CALLING_STEP,
                                            )
                                        }
                                        data-testd="sequence-strategy-continue"
                                    >
                                        <BranchIcon /> Return
                                    </SequenceStrategyLineDiv>
                                )}
                                <SequenceStrategyLineDiv
                                    onClick={() =>
                                        updateSequenceStrategy(sequence, FlowSequenceCompleteStrategy.END_FLOW)
                                    }
                                    data-testd="sequence-strategy-end_flow"
                                >
                                    <ArrowDownIcon /> End flow
                                </SequenceStrategyLineDiv>
                                <SequenceStrategyLineDiv
                                    onClick={() =>
                                        updateSequenceStrategy(sequence, FlowSequenceCompleteStrategy.END_FLOW_IN_ERROR)
                                    }
                                    data-testid="sequence-strategy-end_flow_error"
                                >
                                    <CloseRedIcon /> End flow in error
                                </SequenceStrategyLineDiv>
                            </SequenceStrategyDialog>
                        </ReactDraggable>
                    </ClickAwayListener>
                );
            }}
        />
    );
};
